<template>
  <md-button class="md-info btn_nanosoft">
    <download-excel
      name="تقرير العلاوات السنوية"
      :stringifyLongNum="true"
      :fetch="fetchData"
      :fields="json_fields"
      :header="[name, desc, `تقرير العلاوات السنوية ${convert_Month(month)}`]"
    >
      <!-- :footer="footerArray" -->
      طباعة Excel
    </download-excel>
  </md-button>
</template>

<script>
import axios from "axios";
import env from "../../../env";
export default {
  props: ["name", "desc", "month"],
  data() {
    return {
      json_fields: {
        "ر.ت": "num",
        "رقم الملف الشخصى": "profileNumber",
        الإسم: "employeeName",
        "الوضع الوظيفي": "jobType",
        "تاريخ التوظيف": {
          callback: (value) => {
            return this.convert_excel(value.jobDate);
          },
        },
        // "المؤهل العلمي": "scientificAppointment",
        // التخصص: "specialization",
        "العلاوة الحالية": "currentBonus",
        // "تاريخ الحصول عليها": "lastBonusUpdate",
        // "شهر العلاوة": "monthName",
        "العلاوة المرقة لها": "dueBonus",
      },
    };
  },
  methods: {
    async fetchData() {
      if (this.month == "1970-1-1") {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          "عفواً، الرجاء ادخال من تاريخ الشهر"
        );
      }
      let T = localStorage.getItem("Nannotoken");
      let token = atob(T);
      let res = await axios.get(
        `${env.HR()}/api/hr/employeesReport/GetAnnualBonus?MonthDate=${
          this.month
        }`,
        {
          headers: { Authorization: "Bearer " + token },
        }
      );

      res.data.data.items.forEach((item, i) => {
        item.num = i + 1;
      });

      return res.data.data.items;
    },
    notifyVue(verticalAlign, horizontalAlign, type, message, time = 10000) {
      this.$notify({
        timeout: time,
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
      });
    },
    convert_Month(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return d.getFullYear() + "-" + (d.getMonth() + 1);
      } catch (error) {}
    },
    convert_excel(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return `${d.getFullYear()} - ${d.getMonth() + 1} - ${d.getDate()}`;
      } catch (error) {}
    },
  },
};
</script>

<style lang="scss" scoped>
</style>